import { render } from "./Summarize.vue?vue&type=template&id=164723a0&scoped=true&lang=pug"
import script from "./Summarize.vue?vue&type=script&lang=js"
export * from "./Summarize.vue?vue&type=script&lang=js"

import "./Summarize.vue?vue&type=style&index=0&id=164723a0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-164723a0"]])

export default __exports__